import React, { VFC } from 'react';
import { IIconProps } from './types';

const PackageIcon: VFC<IIconProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m15.833 9.305-7.666-4.61"
      stroke={color}
      strokeWidth={2}
      viewBox="0 0 10 10"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.27 6.96 12 12.01l8.73-5.05M12 22.08V12"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PackageIcon;
